import React from "react";
import classnames from "classnames";
import { Button } from "antd";

class EmptyState extends React.Component {
  render() {
    return (
      <div
        className={classnames(
          this.props.className,
          "empty-state flex-fill d-flex flex-column align-items-center justify-content-center",
          { "py-4": this.props.height > 150, "py-2": this.props.height <= 150 }
        )}
        style={{ minHeight: this.props.height ? this.props.height : "300px" }}
      >
        <i
          className={`icon  icon-${this.props.icon}`}
          style={{ fontSize: "25px" }}
        />
        <h5
          className={classnames("title", {
            "my-3": this.props.height > 180,
            "my-0": this.props.height <= 180
          })}
        >
          {this.props.name}
        </h5>
        {this.props.description && (
          <i className="copy mx-4 text-center">{this.props.description}</i>
        )}
        {this.props.onConfirm && (
          <Button
            className="my-2"
            onClick={this.props.onConfirm}
            type={this.props.buttonType ? this.props.buttonType : "primary"}
          >
            {this.props.buttonLabel ? this.props.buttonLabel : this.props.name}
          </Button>
        )}
      </div>
    );
  }
}

export default EmptyState;



// WEBPACK FOOTER //
// ./src/pages/Patient/EmptyState.js